import { required } from 'vee-validate/dist/rules';
import en from 'vee-validate/dist/locale/en.json';

export default {
  ...required,
  validate: (value, { customValidator = () => true }) => {
    return {
      valid: required.validate(value) && customValidator(value),
      required: true,
    };
  },
  params: required.params.concat(['customValidator']),
  message: `${en.messages.required}.`,
  computesRequired: true,
};
